export var DataRoomStatus;
(function (DataRoomStatus) {
    DataRoomStatus["Live"] = "live";
    DataRoomStatus["Inactive"] = "inactive";
})(DataRoomStatus || (DataRoomStatus = {}));
export const dataRoomStatusValues = Object.values(DataRoomStatus).map((value) => value);
//# sourceMappingURL=index.js.map